import { useMemo } from 'react';
import { useCartItemReference } from './cart-item-reference';

export const useCartSummary = () => {
    const { references$ } = useCartItemReference();

    const cartItemReferences = references$().get();

    const filteredReferences = useMemo(() => {
        return cartItemReferences.filter(ref => ref.cartItemReferenceId && ref?.cartItem != null);
    }, [cartItemReferences]);

    const totalItems = useMemo(() => {
        return filteredReferences.reduce((sum, ref) => {
            const qty = typeof ref.qty === 'number' ? ref.qty : 0;
            return sum + qty;
        }, 0);
    }, [filteredReferences]);

    return {
        cartItemReferences: filteredReferences,
        totalItems,
    };
};
